import React from 'react';
import { FormattedNumber } from 'react-intl';
import Money from '../../../components/Money';
import Button from '../../../components/Button';
import Translate from '../../../components/Translate';

var ActiveLimit = function ActiveLimit(_ref) {
  var remainingAmount = _ref.remainingAmount,
      amount = _ref.amount,
      currency = _ref.currency,
      type = _ref.type;
  return React.createElement(
    'div',
    { className: 'limit-info-container' },
    amount && React.createElement(
      'div',
      { className: 'active-limit-content' },
      React.createElement(
        'div',
        { className: 'limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.current-limit',
          defaultMessage: 'Current limit'
        })
      ),
      !['LoginTime', 'RealityCheck', 'Session', 'ProductSession'].includes(type) && React.createElement(
        'div',
        { className: 'active-limit-value' },
        React.createElement(Money, { decimals: false, value: amount, currency: currency })
      ),
      type === 'LoginTime' && React.createElement(
        'div',
        { className: 'active-limit-value' },
        amount,
        ' ',
        React.createElement(Translate, { id: 'label.hours-short', defaultMessage: 'h' })
      ),
      ['RealityCheck', 'Session', 'ProductSession'].includes(type) && React.createElement(
        'div',
        { className: 'active-limit-value' },
        amount,
        ' ',
        React.createElement(Translate, { id: 'label.minutes', defaultMessage: 'min' })
      )
    ),
    remainingAmount !== null && type !== 'RealityCheck' && type !== 'Session' && React.createElement(
      'div',
      { className: 'active-limit-content' },
      React.createElement(
        'div',
        { className: 'active-limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.remaining-limit',
          defaultMessage: 'Remaining limit'
        })
      ),
      !['LoginTime', 'ProductSession'].includes(type) ? React.createElement(
        'div',
        { className: 'active-limit-value' },
        React.createElement(Money, {
          decimals: false,
          value: remainingAmount,
          currency: currency
        })
      ) : type === 'LoginTime' ? React.createElement(
        'div',
        { className: 'active-limit-value' },
        remainingAmount,
        ' ',
        React.createElement(Translate, { id: 'label.hours-short', defaultMessage: 'h' })
      ) : React.createElement(
        'div',
        { className: 'active-limit-value' },
        remainingAmount,
        ' ',
        React.createElement(Translate, { id: 'label.minutes', defaultMessage: 'min' })
      )
    )
  );
};

var ExtraLimit = function ExtraLimit(_ref2) {
  var amount = _ref2.amount,
      currency = _ref2.currency,
      handlePickLimit = _ref2.handlePickLimit,
      id = _ref2.id;
  return React.createElement(
    'div',
    { className: 'limit-info-container' },
    amount && React.createElement(
      'div',
      { className: 'extra-limit-content' },
      React.createElement(
        'div',
        { className: 'limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.extra-limit',
          defaultMessage: 'Limit'
        })
      ),
      React.createElement(
        'div',
        { className: 'extra-limit-value' },
        React.createElement(Money, { value: amount, currency: currency })
      ),
      React.createElement(
        Button,
        {
          type: 'button',
          className: 'button tertiary tiny extra-limit-button',
          onClick: function onClick() {
            return handlePickLimit(id);
          } },
        React.createElement(Translate, { id: 'action.pick.limit', defaultMessage: 'Pick' })
      )
    )
  );
};

var TransactionLimit = function TransactionLimit(_ref3) {
  var amount = _ref3.amount,
      currency = _ref3.currency,
      handleCancel = _ref3.handleCancel,
      id = _ref3.id;
  return React.createElement(
    'div',
    { className: 'transaction-limit-content' },
    React.createElement(
      'div',
      { className: 'limit-name' },
      React.createElement(Translate, {
        id: 'message.responsiblegaming.transaction-limit',
        defaultMessage: 'Transaction limit',
        tagName: 'p'
      }),
      ': ',
      React.createElement(Money, { decimals: false, value: amount, currency: currency })
    ),
    React.createElement(
      'div',
      { className: 'transaction-limit-value' },
      React.createElement(
        'a',
        {
          href: '#',
          onClick: function onClick(e) {
            e.preventDefault();
            handleCancel(id);
          } },
        React.createElement(Translate, { id: 'action.delete.limit', defaultMessage: 'Delete' })
      )
    )
  );
};

var DeletedLimit = function DeletedLimit(_ref4) {
  var amount = _ref4.amount,
      currency = _ref4.currency,
      date = _ref4.date,
      timespan = _ref4.timespan,
      type = _ref4.type,
      jurisdiction = _ref4.jurisdiction;
  return React.createElement(
    'div',
    { className: 'pending-limit-info-container' },
    React.createElement(
      'div',
      { className: 'pending-limit-content' },
      !['LoginTime', 'ProductSession'].includes(type) ? React.createElement(
        'div',
        null,
        React.createElement(Translate, {
          id: 'message.responsiblegaming.deleted-limit.' + timespan,
          defaultMessage: 'This limit of {amount} {currency} will be deleted in {date}',
          values: {
            date: React.createElement(
              'span',
              null,
              date
            ),
            amount: React.createElement(FormattedNumber, { value: amount }),
            currency: React.createElement(
              'span',
              null,
              currency
            )
          }
        })
      ) : React.createElement(
        'div',
        null,
        React.createElement(Translate, {
          id: 'message.responsiblegaming.deleted-period-limit',
          defaultMessage: 'This limit of {amount} {hour} will be deleted in {date}',
          values: {
            date: React.createElement(
              'span',
              null,
              date
            ),
            amount: React.createElement(FormattedNumber, { value: amount }),
            hour: React.createElement(
              'span',
              null,
              type === 'LoginTime' ? 'h' : 'm'
            )
          }
        })
      )
    )
  );
};

var ConfirmLimit = function ConfirmLimit(_ref5) {
  var amount = _ref5.amount,
      type = _ref5.type,
      timespan = _ref5.timespan,
      currency = _ref5.currency,
      status = _ref5.status;
  return React.createElement(
    'div',
    { className: 'confirm-limit' },
    type !== 'RealityCheck' && type !== 'Session' && React.createElement(
      'div',
      null,
      status !== 'Canceled' ? React.createElement(Translate, {
        id: 'message.responsiblegaming.confirm-limit.' + timespan,
        defaultMessage: 'You have a limit of {amount} {currency} to confirm.',
        tagName: 'div',
        values: {
          amount: React.createElement(FormattedNumber, { value: amount }),
          currency: React.createElement(
            'span',
            null,
            currency
          )
        }
      }) : React.createElement(Translate, {
        id: 'message.responsiblegaming.confirm-deleted-limit.' + timespan,
        defaultMessage: 'Confirm that you want to remove your limit of {amount} {currency}',
        tagName: 'div',
        values: {
          amount: React.createElement(FormattedNumber, { value: amount }),
          currency: React.createElement(
            'span',
            null,
            currency
          )
        }
      })
    ),
    (type === 'RealityCheck' || type === 'Session') && React.createElement(Translate, {
      id: 'message.responsiblegaming.confirm-limit-minutes',
      defaultMessage: 'Confirm Limit',
      tagName: 'div',
      values: {
        amount: React.createElement(FormattedNumber, { value: amount })
      }
    })
  );
};

var PendingLimit = function PendingLimit(_ref6) {
  var date = _ref6.date,
      type = _ref6.type,
      amount = _ref6.amount,
      currency = _ref6.currency;
  return React.createElement(
    'div',
    { className: 'pending-limit-info-container' },
    React.createElement(
      'div',
      { className: 'pending-limit-content' },
      React.createElement(
        'div',
        { className: 'pending-limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.pending-limit-activation',
          defaultMessage: 'Time until active'
        })
      ),
      React.createElement(
        'div',
        { className: 'pending-limit-value' },
        date
      )
    ),
    React.createElement(
      'div',
      { className: 'pending-limit-content' },
      React.createElement(
        'div',
        { className: 'pending-limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.pending-limit',
          defaultMessage: 'New limit'
        })
      ),
      React.createElement(
        'div',
        { className: 'pending-limit-value' },
        !['LoginTime', 'Session', 'ProductSession'].includes(type) && React.createElement(Money, { decimals: false, value: amount, currency: currency }),
        ['Session', 'ProductSession'].includes(type) && React.createElement(
          'div',
          null,
          amount,
          ' ',
          React.createElement(Translate, { id: 'label.minutes', defaultMessage: 'min' })
        ),
        type === 'LoginTime' && React.createElement(
          'div',
          null,
          amount,
          ' ',
          React.createElement(Translate, { id: 'label.hours-short', defaultMessage: 'h' })
        )
      )
    )
  );
};

var CooldownLimit = function CooldownLimit(_ref7) {
  var date = _ref7.date,
      type = _ref7.type,
      amount = _ref7.amount,
      currency = _ref7.currency;
  return React.createElement(
    'div',
    { className: 'cooldown-limit-info-container' },
    React.createElement(
      'div',
      { className: 'cooldown-limit-content' },
      React.createElement(
        'div',
        { className: 'cooldown-limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.cooldown-limit-confirmation',
          defaultMessage: 'Time until confirmation'
        })
      ),
      React.createElement(
        'div',
        { className: 'cooldown-limit-value' },
        date
      )
    ),
    React.createElement(
      'div',
      { className: 'cooldown-limit-content' },
      React.createElement(
        'div',
        { className: 'cooldown-limit-name' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.cooldown-limit',
          defaultMessage: 'New limit'
        })
      ),
      React.createElement(
        'div',
        { className: 'cooldown-limit-value' },
        !['LoginTime', 'RealityCheck', 'Session'].includes(type) ? React.createElement(Money, { decimals: false, value: amount, currency: currency }) : React.createElement(
          'div',
          null,
          amount,
          ' ',
          type === 'RealityCheck' || type === 'Session' ? React.createElement(Translate, { id: 'label.minutes', defaultMessage: 'min' }) : React.createElement(Translate, { id: 'label.hours-short', defaultMessage: 'h' })
        )
      )
    )
  );
};

export { ActiveLimit, ExtraLimit, ConfirmLimit, PendingLimit, DeletedLimit, TransactionLimit, CooldownLimit };